import { createContext, useState } from "react";

const initialMetric = { value: "investment", label: "Inversión" };

const ActionsPerformanceMetricsChartContext = createContext({
  selectedMetric: initialMetric,
  setSelectedMetric: null,
  selectedGroupingDimension: null,
  setSelectedGroupingDimension: null,
});

export const ActionsPerformanceMetricsChartProvider = ({ children }) => {
  const [selectedMetric, setSelectedMetric] = useState(initialMetric);
  const [selectedGroupingDimension, setSelectedGroupingDimension] = useState();
  const value = {
    selectedMetric,
    setSelectedMetric,
    selectedGroupingDimension,
    setSelectedGroupingDimension,
  };

  return (
    <ActionsPerformanceMetricsChartContext.Provider value={value}>
      {children}
    </ActionsPerformanceMetricsChartContext.Provider>
  );
};

export default ActionsPerformanceMetricsChartContext;